import type { Shadows } from '@mui/material/styles/shadows';

export const shadows = [
  'none',
  '0px 1px 2px rgba(0, 0, 0, 0.18)',
  '0px 1px 5px rgba(0, 0, 0, 0.18)',
  '0px 1px 8px rgba(0, 0, 0, 0.18)',
  '0px 2px 10px rgba(0, 0, 0, 0.20)',
  '0px 2px 14px rgba(0, 0, 0, 0.20)',
  '0px 3px 18px rgba(0, 0, 0, 0.22)',
  '0px 3px 16px rgba(0, 0, 0, 0.22)',
  '0px 4px 18px rgba(0, 0, 0, 0.24)',
  '0px 4px 20px rgba(0, 0, 0, 0.24)',
  '0px 5px 22px rgba(0, 0, 0, 0.26)',
  '0px 5px 24px rgba(0, 0, 0, 0.26)',
  '0px 6px 26px rgba(0, 0, 0, 0.28)',
  '0px 6px 28px rgba(0, 0, 0, 0.28)',
  '0px 7px 30px rgba(0, 0, 0, 0.30)',
  '0px 7px 32px rgba(0, 0, 0, 0.30)',
  '0px 8px 34px rgba(0, 0, 0, 0.32)',
  '0px 8px 36px rgba(0, 0, 0, 0.32)',
  '0px 9px 38px rgba(0, 0, 0, 0.34)',
  '0px 9px 40px rgba(0, 0, 0, 0.34)',
  '0px 10px 42px rgba(0, 0, 0, 0.36)',
  '0px 10px 44px rgba(0, 0, 0, 0.36)',
  '0px 11px 46px rgba(0, 0, 0, 0.38)',
  '0px 11px 48px rgba(0, 0, 0, 0.38)',
  '0px 12px 50px rgba(0, 0, 0, 0.40)',
] satisfies Shadows;
